export const isSectionLabelHidden = ({size}) => size.width < 8 || size.height < 5;
